
import { defineComponent } from 'vue';

import Template from '@/components/Templates/index.vue';
import TestimonialDetails from '@/components/TestimonialDetail/Template1/index.vue';
import { TESTIMONIAL_DETAIL_PAGE_NAMES } from '@/ts/enum';

export default defineComponent({
  name: TESTIMONIAL_DETAIL_PAGE_NAMES.POYANIL_HOSPITAL,
  components: {
    TestimonialDetails,
    Template,
  },
});
